import jsPDF from "jspdf";

const eur = (n) => `EUR ${Number(n || 0).toLocaleString("it-IT", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
const pct = (v) => (v == null ? "—" : `${v > 0 ? "+" : ""}${v}%`);

export async function generateAnalyticsPdf({ data, ai, foodCost, range, business }) {
  const doc = new jsPDF({ unit: "mm", format: "a4" });
  const logo = await new Promise((res) => {
    fetch("/logo-dogana.png").then((r) => r.blob()).then((b) => { const fr = new FileReader(); fr.onload = () => res(fr.result); fr.onerror = () => res(null); fr.readAsDataURL(b); }).catch(() => res(null));
  });
  if (logo) { try { doc.addImage(logo, "PNG", 12, 9, 20, 20); } catch { /* noop */ } }
  const hx = logo ? 37 : 12;
  doc.setFontSize(14); doc.setFont(undefined, "bold"); doc.text(business?.name || "Dogana 2.0", hx, 16);
  doc.setFontSize(9); doc.setFont(undefined, "normal");
  doc.text([business?.address, business?.vat ? `P.IVA ${business.vat}` : null].filter(Boolean).join(" · "), hx, 21);
  doc.setFontSize(13); doc.setFont(undefined, "bold");
  doc.text(`Analisi gestionale — dal ${range.from || "inizio"} al ${range.to || "oggi"}`, 12, 38);
  doc.setFontSize(8); doc.setFont(undefined, "normal"); doc.setTextColor(120);
  doc.text(`Generato il ${new Date().toLocaleString("it-IT")}`, 12, 43);
  doc.setTextColor(0);

  let y = 52;
  const line = (label, value, extra) => {
    doc.setFont(undefined, "bold"); doc.text(label, 14, y);
    doc.setFont(undefined, "normal"); doc.text(value, 110, y, { align: "right" });
    if (extra) { doc.setTextColor(120); doc.text(extra, 150, y, { align: "right" }); doc.setTextColor(0); }
    y += 6;
  };
  const section = (title) => { if (y > 265) { doc.addPage(); y = 20; } y += 4; doc.setFontSize(11); doc.setFont(undefined, "bold"); doc.setTextColor(194, 65, 39); doc.text(title, 12, y); doc.setTextColor(0); doc.setFontSize(9); doc.setFont(undefined, "normal"); y += 7; };

  section("Riepilogo");
  const d = data.delta || {};
  line("Incassi totali", eur(data.income?.total), `vs periodo prec. ${pct(d.income)}`);
  line("  di cui ufficiali", eur(data.income?.ufficiale));
  line("  di cui preventivi", eur(data.income?.black));
  line("Spese totali", eur(data.expense?.total), `vs periodo prec. ${pct(d.expense)}`);
  line("  ufficiali / black / fuori cassa", `${eur(data.expense?.ufficiale)} / ${eur(data.expense?.black)} / ${eur(data.expense?.fuori_cassa)}`);
  line("Utile", eur(data.profit), `vs periodo prec. ${pct(d.profit)}`);
  line("Margine", `${data.margin_pct ?? 0}%`);
  line("Incasso medio giornaliero", eur(data.avg_daily_income), `${data.income_days || 0} giorni con incassi`);
  if (data.best_day) line("Giorno migliore", `${data.best_day.date} · ${eur(data.best_day.incassi)}`);
  if (data.previous) { doc.setTextColor(120); doc.text(`Periodo precedente: ${data.previous.from_date} → ${data.previous.to_date} · incassi ${eur(data.previous.income?.total)} · spese ${eur(data.previous.expense?.total)}`, 14, y); doc.setTextColor(0); y += 6; }

  if (foodCost && foodCost.rows?.length) {
    section("Food cost reale (venduto × ricette)");
    line("Ricavi piatti abbinati", eur(foodCost.revenue));
    line("Costo materie prime", eur(foodCost.cost), `incidenza ${foodCost.fc_pct}%`);
    if (foodCost.unmatched_revenue) line("Venduto senza ricetta", eur(foodCost.unmatched_revenue));
    foodCost.rows.slice(0, 12).forEach((r) => line(`  ${r.recipe} (${r.qty} pz)`, eur(r.revenue), `FC ${r.fc_pct}%`));
  }

  if (data.expense_by_category?.length) {
    section("Spese per categoria");
    data.expense_by_category.slice(0, 12).forEach((c) => line(`  ${c.category}`, eur(c.amount)));
  }
  if (data.top_products?.length) {
    section("Prodotti più venduti");
    data.top_products.slice(0, 12).forEach((p) => line(`  ${p.product} (${p.qty} pz)`, eur(p.amount)));
  }

  if (ai) {
    section(`Analisi AI — stato: ${ai.health || "—"}`);
    const wrap = (t) => doc.splitTextToSize(t, 180);
    const block = (title, arr) => {
      if (!arr?.length) return;
      if (y > 260) { doc.addPage(); y = 20; }
      doc.setFont(undefined, "bold"); doc.text(title, 14, y); y += 5; doc.setFont(undefined, "normal");
      arr.forEach((s) => { const ls = wrap(`• ${s}`); if (y + ls.length * 5 > 285) { doc.addPage(); y = 20; } doc.text(ls, 16, y); y += ls.length * 5 + 1; });
      y += 2;
    };
    const sum = wrap(ai.summary || ""); doc.text(sum, 14, y); y += sum.length * 5 + 3;
    block("Punti di forza", ai.strengths); block("Attenzione", ai.warnings); block("Consigli", ai.suggestions);
  }
  doc.save(`analisi-${range.from || "tutto"}_${range.to || "oggi"}.pdf`);
}
